import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";
import image from '../image/5cf2660af5f4214def7166dc7a7c8062.jpg';

export const Nav = styled.nav`
   background-image: linear-gradient(to right, #2e7fc2 0%, #6acad2 100%);
    background-size: cover;
    background-position: center; 
    padding: 20px;
    height: 130vh; 
    display: flex;
    align-items: flex-start;
`;

export const NavLogo = styled(Link)`
  font-size: 5rem;
  text-decoration: none;
`;

export const NavLink = styled(Link)`
  text-decoration: none;
  font-size: 22px;
  color: white;

  &:hover {
    color: white;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #1866db;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
  }
`;

export const NavMenu = styled.div`
  margin-right: -24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px; 
`;

export const NavBtn = styled.nav`
  align-items: center;
  margin-right: 24px;
`;
